import mountApp from 'cfg/mountApp';
import Quiz     from './Vue/Quiz.vue';


export default (selector, options = {})=> {
  const vueOptions = {
    translationDomain: 'quiz',
    components: { Quiz },
    data() {
      return {
        start: options.start || '',
      };
    },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
